import styled from 'styled-components';
import { Typography, CardContent as MuiCardContent } from '@mui/material';

export const Container = styled.div`
  width: 100%;
  padding: 10px;
  height: auto;
`;

export const Col = styled.div`
  display: flex;
  flex: 1;
  padding: 10px;
  align-items: center;
  text-align: center;
`;

export const Row = styled.div`
  display: flex;
  min-height: 50px;
`;

export const YearRow = styled.div`
  padding: 10px;
  display: block;
  width: 100%;
  height: auto;
  border: 1px solid rgba(0, 0, 0, 0.12);
  border-radius: 4px;
  box-sizing: border-box;
  margin-bottom: 10px;
`;

export const Scroller = styled.div`
  display: inline-block;
  justify-content: space-around;
  max-width: 100%;
`;

export const Item = styled.div`
  height: 154px;
  width: 200px;
  display: inline-table;
`;

export const Link = styled(Typography)`
  font-size: 1.1rem;
  background-color: #f8984e75;
  cursor: pointer;
  padding-top: 5px;
  padding-bottom: 5px;
  color: black !important;
  font-weight: bold !important;
  :hover {
    text-decoration: underline;
  }
`;

export const Text = styled(Typography)`
  color: ${props => props.color};
`;

export const TextContainer = styled.div`
  width: 200px;
  white-space: 'nowrap';
`;

export const CardContent = styled(MuiCardContent)`
  padding: 0 !important;
`;

export const EmptyMessage = styled(Typography)`
  margin-top: 60px important;
  font-size: 0.9rem important;
`;

export const TotalText = styled(Typography)`
  width: 100%;
`;

export const TitleCard = styled(Typography)`
  fontSize: 0.875rem;
  fontWeight: bold;
  color: #0091ae;
  textTransform: uppercase;
  lineHeight: 1.75;
  :hover: {
    color: #0091ae55;
  }
`;